import { ApiModule } from '@core';
import { type PaginatedApiResponse, type PaginatedResponseData } from '@common';
import type { DecisionSupportItem } from '../models';
import type { SaveDecisionSupportWizardData } from '../models/decision-support-wizard.model';

export class DecisionSuportApi extends ApiModule {
  protected endpoint = '/maximap/statistics';

  public getDecisionSupport(filters: any = {}): Promise<PaginatedApiResponse<DecisionSupportItem>> {
    return this.api.get<PaginatedResponseData<DecisionSupportItem>>(`${this.endpoint}/decision-support`, {
      params: filters
    });
  }

  public deleteDecisionSupport(id: string) {
    return this.api.delete(`${this.endpoint}/${id}`);
  }

  public createDecisionSupport(decisionSupport: SaveDecisionSupportWizardData) {
    return this.api.post<any, SaveDecisionSupportWizardData>(`${this.endpoint}/create`, decisionSupport);
  }
}
